import type {Result, UseCase} from 'framework';
import type {BodyMetricWithEntryCount} from '../../domain/body-metric';
import type {BodyMeasurementsError} from '../../domain/errors';
import type {BodyMeasurementsRepository} from '../ports/body-measurements.repository';

export class ListBodyMetrics implements UseCase<[], readonly BodyMetricWithEntryCount[]> {
  constructor(private readonly repository: BodyMeasurementsRepository) {}

  execute(): Promise<Result<readonly BodyMetricWithEntryCount[], BodyMeasurementsError>> {
    return this.repository.listMetrics();
  }
}
